export default "__VITE_ASSET__85dc7e56__"